import { render, staticRenderFns } from "./IpoSummaries.vue?vue&type=template&id=376b63f1"
import script from "./IpoSummaries.vue?vue&type=script&lang=js"
export * from "./IpoSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports